import { memo } from "react";

import type { LangCode, RoomI18n_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { FeatureIslandHeader } from "@/components/features/_layouts";

import { MagazineEditor } from "../../../../_shared/ui/component/editor/magazine-editor";
import { DesignMagazineHeaderRightChildren } from "../../../../_shared/ui/component/header/right-children";
import { getMagazineEditPageUrl } from "../../../../_shared/utils/get-magazine-edit-page-url";
import { useInitialized } from "../../model/usecase/use-initialized";

type Props = {
	hotelID: string;
	roomID: string;
	langCode: LangCode;
	serverModel: RoomI18n_DesignPageQuery;
};

export const DesignMagazineRoomArticleI18nEditPresenter = memo(({ hotelID, roomID, langCode, serverModel }: Props) => {
	const { articleHTML, isValid, isDirty, data, onUpdate, onSetArticleHTML } = useInitialized({
		hotelID,
		roomID,
		langCode,
		data: serverModel,
	});
	const { name } = data.roomI18n;

	useTransitionBlock(isDirty);

	return (
		<div>
			<FeatureIslandHeader
				title="部屋記事の編集"
				activeLangCode={langCode}
				navigator={{
					default: getMagazineEditPageUrl({
						hotelID,
						magazineResourceID: roomID,
						magazineResourceType: "Room",
					}),
					i18n: (lang) =>
						getMagazineEditPageUrl({
							hotelID,
							magazineResourceID: roomID,
							magazineResourceType: "Room",
							langCode: lang,
						}),
				}}
				rightChildren={<DesignMagazineHeaderRightChildren isValid={isValid} onUpdate={onUpdate} />}
			/>

			{Boolean(articleHTML) && (
				<MagazineEditor
					resourceName={name}
					tiptapEditorProps={{
						content: articleHTML,
						hotelID,
						handleEditorContentChange: onSetArticleHTML,
					}}
				/>
			)}
		</div>
	);
});

DesignMagazineRoomArticleI18nEditPresenter.displayName = "DesignMagazineRoomArticleI18nEdit";
